import { EventType } from '../../shared/models/api/event.model';

export const eventTypeTranslation: Readonly<Record<EventType, string>> = {
  [EventType.LUNCH_AND_DINNER]: 'EVENTS.TYPE.LUNCH_AND_DINNER',
  [EventType.FUN_AND_GAMES]: 'EVENTS.TYPE.FUN_AND_GAMES',
};
